import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CardBody, Collapse } from "reactstrap";
import "../../../App.css"; // Import the CSS file
import { GET, newFetch } from "../../../helpers/fetch";
import Spinner from "../../SpringLoader/index";

const LeaveEntitlement = () => {
  const { t } = useTranslation();
  const [leaveList, setLeaveList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [accordionState, setAccordionState] = useState({});

  const associateId = JSON.parse(localStorage.getItem("user")).id;

  const fetchLeaveAll = async () => {
    try {
      setLoading(true);
      const api_path = `/associate-leave-summary/all/${associateId}`;
      const response = await newFetch(GET, api_path);

      if (response.success) {
        setLeaveList(response.data);
      } else {
        setLeaveList([]);
      }
    } catch (error) {
      console.error("Error fetching full leave summary:", error);
      setLeaveList([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleAccordion = (leaveTypeId) => {
    setAccordionState((prevState) => {
      const isCurrentlyOpen = prevState[leaveTypeId];
      return isCurrentlyOpen ? {} : { [leaveTypeId]: true };
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // dd/mm/yyyy
  };

  useEffect(() => {
    fetchLeaveAll();
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="container pt-4">
      <h4 className="text-brand leave-title">
        <Link to="/leave">
          <i className="fas fa-arrow-left link" />
        </Link>
        &nbsp;&nbsp;{t("Leave Entitlement")}
      </h4>

      <CardBody className="leave-card-body">
        <div id="leaveAccordion" className="leave-accordion">
          {leaveList?.map((leave) => {
            const isOpen = accordionState[leave.leave_type_id];

            return (
              <div key={leave.leave_type_id} className="leave-item">
                <button
                  className={`leave-header ${isOpen ? "open" : ""}`}
                  onClick={() => toggleAccordion(leave.leave_type_id)}
                >
                  <div className="leave-info">
                    <span className="leave-name">
                      {t(leave.leave_type?.leave_name) || "Unknown Leave Type"}
                    </span>
                    <small className="leave-available">
                      {t("Available")}: {leave.available || 0}
                    </small>
                  </div>
                  <span className={`leave-icon ${isOpen ? "rotate" : ""}`}>
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                <Collapse isOpen={isOpen}>
                  <div className="leave-content">
                    <div
                      className={`leave-inner ${
                        window.innerWidth < 768 ? "column" : "row"
                      }`}
                    >
                      <div className="leave-left">
                        {[
                          {
                            label: "Max Per Year",
                            value: leave.max_leaves || 0,
                          },
                          { label: "Balance", value: leave.available || 0 },
                          { label: "Taken", value: leave.taken || 0 },
                          { label: "Pending", value: leave.pending || 0 },
                        ].map((item, idx) => (
                          <div key={idx} className="leave-stat">
                            <span className="leave-label">
                              {t(item.label)}:
                            </span>
                            <span className="leave-value">{item.value}</span>
                          </div>
                        ))}
                      </div>

                      {window.innerWidth >= 768 && (
                        <div className="leave-divider" />
                      )}

                      <div className="leave-right">
                        <span className="leave-active-label">
                          {t("Active Period")}
                        </span>
                        <div className="leave-active-dates">
                          <span className="leave-date">
                            {formatDate(leave.active_date)}
                          </span>
                          <span className="leave-date-sep">–</span>
                          <span className="leave-date">
                            {formatDate(leave.expiry_date)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      </CardBody>
    </div>
  );
};

export default LeaveEntitlement;
